import React from "react";
import { Button } from "@design-system/Button/Button";
import { EmptyState } from "@design-system/EmptyState/EmptyState";

interface Props {
    isFiltered: boolean;
    onViewVendors?: () => void;
    onUpdateMapping?: () => void;
}

export const Form1099NecEmptyState: React.FC<Props> = ({
    isFiltered,
    onViewVendors,
    onUpdateMapping,
}) => {
    if (isFiltered) {
        return (
            <EmptyState header="No recipients match your search or filters" />
        );
    }
    return (
        <EmptyState
            header="No 1099 recipients for the selected year"
            body="Recipients appear once a vendor is marked 1099 eligible and paid from an account mapped to a 1099 box"
            cta={
                <>
                    {onUpdateMapping && (
                        <Button
                            variant="secondary"
                            size="md"
                            onClick={onUpdateMapping}
                        >
                            Update mapping
                        </Button>
                    )}
                    {onViewVendors && (
                        <Button
                            variant="primary"
                            size="md"
                            onClick={onViewVendors}
                        >
                            View vendors
                        </Button>
                    )}
                </>
            }
        />
    );
};
